<template>
  <b-modal :active.sync="isModalActive" has-modal-card :can-cancel="true">
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Report Definition List</h1>
      </header>
      <section class="modal-card-body overflow-scroll">
        <div class="columns">
          <div class="column">
            <ol class="report-defition-list-ol">
              <li
                v-for="(value, index) in formData.report_definition"
                :key="index"
              >
                <router-link
                  :to="{
                    path: `/rulesManager/reportDefinition/${value.id}/view`
                  }"
                  target="_blank"
                >
                  {{ value.name }}
                </router-link>
              </li>
            </ol>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" class="is-normal" @click="cancel">
          Cancel
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "ViewReportView",
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object
    },
    formData: {
      type: Object
    }
  },

  data() {
    return {
      isModalActive: false
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    redirectToReportDefinition(value) {
      this.$router
        .push({
          path: `/rulesManager/reportDefinition/${value.id}/view`
        })
        .catch();
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
